import './style.scss';

function PageSidebar(props) {
  return (
    <aside className="PageSidebar">
      {props.children ? props.children : "This sidebar has no items"}
    </aside>
  );
}

export default PageSidebar;